module.exports = __webpack_public_path__ + "img/testimony-1.e1207d65.png";